<template>
  <div class="box">
    <div class="header">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt />
      </div>
    </div>
    <div class="content">
      <!-- <van-steps active-color="#228ccd" :active="active">
        <van-step>填写账号信息</van-step>
        <van-step>设置新密码</van-step>
        <van-step>完成</van-step>
      </van-steps>
      <div class="step-content">
        <step-base @success="success" v-if="active === 0"></step-base>
        <step-new  @success="active=2" v-else-if="active === 1" :mobile="mobile"></step-new>
        <step-successed v-else></step-successed>
      </div> -->
      <van-steps active-color="#228ccd" :active="active">
        <van-step>设置新密码</van-step>
        <van-step>完成</van-step>
      </van-steps>
      <div class="step-content">
        <forgetPassWord @success="success" v-if="active === 0"></forgetPassWord>
        <step-successed v-else></step-successed>
      </div>
      <p class="login-box">
        已有账号，
        <span @click="go('login')">立即登录</span>
      </p>
    </div>
  </div>
</template>

<script>
  import { Step, Steps } from "vant";
  import stepBase from "./base";
  import stepNew from "./newPW";
  import stepSuccessed from "./successed";
  import forgetPassWord from "./forgetPassWord";

  export default {
    data() {
      return {
        active: 0
      };
    },
    components: {
      [Step.name]: Step,
      [Steps.name]: Steps,
      stepBase,
      stepNew,
      stepSuccessed,
      forgetPassWord
    },
    methods: {
      go(pathName) {
        this.$router.push({ name: pathName });
      },
      success(mobile) {
        this.active = 1;
        this.mobile = mobile;
      }
    }
  };
</script>

<style lang="less" scoped>
  .header {
    height: 225px;
    background: url("../../assets/images/black.jpg") 0 0 / contain repeat;

    .logo {
      padding-top: 70px;

      img {
        display: block;
        width: 70px;
        height: 70px;
        margin: 0 auto;
      }
    }
  }

  .content {
    padding: 36px 40px;
  }

  .login-box {
    text-align: center;
    margin-top: 20px;
    font-size: 14px;

    span {
      color: #228ccd;
    }
  }
</style>